import { FC, useContext, useEffect, useState } from "react";
import Select, { GroupBase, OptionsOrGroups } from "react-select";
import { useForm, Controller } from "react-hook-form";
import { useDebouncedCallback } from "use-debounce";
import { addDays, format, parse, subMonths } from "date-fns";
import DatePicker from "react-datepicker";
import ReactInputMask from "react-input-mask";

import StatsReports from "../../statsReports";

import { AuthContext } from "src/context/authContext";
import { downloadExcelFile } from "src/helpers/downloadFile";
import { ToastContext } from "src/context/toastContext";
import { LoaderContext } from "src/context/loaderContext";
import useFetch from "src/hooks/useFetch";

import { PatientFiltersState } from "src/pages/patient/types";
import { StatisticsProps } from "./types";
import { DownloadReportsResponseTypeApi } from "../../statsReports/types";
import { APIEndpoints } from "src/types/apiTypes";
import { ToastTypes } from "src/types";
import { isPhiEligible } from "src/helpers";
// import ContactAndSafetyInfo from "src/components/contactAndSafetyInfo";



const PatientFilterHCP: FC<StatisticsProps> = ({ updateQueryParams, defaultQueryParams, practiceDropdown, doctorDropdown, onClickDownloadableButton }): JSX.Element => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [filteredDocListing, updatedFilteredDocListing] = useState<{ id: number; name: string; }[]>([])
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [filteredPracticeListing, updatedFilteredPracticeListing] = useState<{ id: number; name: string; }[]>([])
  //const [isExportingInProgress, setExportingInProgressStatus] = useState<boolean>(false);
  const [hasAppliedFilters, setHasAppliedFilters] = useState(false);

  const { control, handleSubmit, reset, getValues, watch ,resetField,setValue} = useForm<PatientFiltersState>({
    mode: 'all',
    defaultValues: defaultQueryParams,
  });
  const start_date = watch("start_date");
  const end_date = watch("end_date");
  const [enabledButton, setEnabledButton] = useState<boolean>(false);
  const { showToast } = useContext(ToastContext);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { setLoader, hideLoader } = useContext(LoaderContext);
  const { isManufacturer, userData } = useContext(AuthContext)
  // console.log("defaultQueryParams", defaultQueryParams)
  // const firstUpdate = useRef(true);
  // const { getManufactureUser, userData } = useContext(AuthContext);
  // useEffect(() => {
  //   if (firstUpdate.current) {
  //     firstUpdate.current = false;
  //     setUserManufactureData()
  //   }
  // }, []);
  // const setUserManufactureData = () => {
  //   const user = getManufactureUser();
  //   if (user === null) {
  //     setValue("ref_user", userData ? userData.id.toString() : " ");
  //   } else {
  //     setValue("ref_user", user ? user.userId.toString() : " ");
  //   }
  // }

  //:- Filtering practice from api recieved listing
  // const filterPractice = (search: string) => {
  //   if (search.length >= 2) {
  //     updatedFilteredPracticeListing(
  //       practiceDropdown.filter((prac) => prac.name.toLowerCase().includes(search.toLowerCase()))
  //     )
  //   }
  // };
  // const debouncedFilterPractice = useDebouncedCallback(filterPractice, 500);
  useEffect(() => {
    if (!defaultQueryParams) return;
    reset(defaultQueryParams);
  }, [defaultQueryParams, reset]);


  //:- Filtereing doctor from api recieved listing
  const filterDoctor = (search: string) => {
    if (search.length >= 2) {
      updatedFilteredDocListing(
        doctorDropdown.filter((doc) => doc.name.toLowerCase().includes(search.toLowerCase()))
      )
    }
  };
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const debouncedFilterDoctor = useDebouncedCallback(filterDoctor, 500);


  const searchForStats = (values: PatientFiltersState) => {
    const updatedValues = {
      ...defaultQueryParams,
      ...values,
      role: defaultQueryParams?.role || "",
      id: defaultQueryParams?.id || "",
      global_doctor_id:
        values.global_doctor_id ?
          (typeof values.global_doctor_id === "string" ? values.global_doctor_id : (values.global_doctor_id as unknown as { value: string; label: string; }).value)
          : "",
      practice_id:
        values.practice_id ?
          (typeof values.practice_id === "string" ? values.practice_id : (values.practice_id as unknown as { value: string; label: string; }).value)
          : "",
    };

    updateQueryParams(updatedValues, false);
    setHasAppliedFilters(true);
  };

  const clearFormData = () => {
    const values = {
      ...defaultQueryParams,
      start_date: format(subMonths(new Date(), 2), 'yyyy-MM-dd'),
      end_date: format(addDays(new Date(), 1), 'yyyy-MM-dd'),
      ...(["Practice", "Contact"].includes(userData?.ref_type || "") ? 
        { practice_id: practiceDropdown?.[0]?.id.toString() ?? "" } : { practice_id: "" }
      ),
      ...(["GlobalDoctor"].includes(userData?.ref_type || "") ?
        { global_doctor_id: userData?.ref_id?.toString() ?? "" } : { global_doctor_id: "" }
      ),
      case_id: "",
      global_patient_id: "",
      patient_name: "",
    };
    if (!["Practice", "Contact", "GlobalDoctor"].includes(userData?.ref_type || ""))
      getProvidersListing({}, {}, { practice_id: [] });

    reset(values);
    updatedFilteredPracticeListing([]);
    updateQueryParams(values as any, true);
    setHasAppliedFilters(false);
  };

  const {
    data: downloadReportsData, error: downloadReportsError, mutate: downloadRequestForm
  } = useFetch<DownloadReportsResponseTypeApi>(APIEndpoints.MANUFACTURE_STATISTICS_REPORT_DOWNLOAD);

  useEffect(() => {
    if (downloadReportsData || downloadReportsError) {
      if (downloadReportsData) {
        const { response, report_name } = downloadReportsData;
        downloadExcelFile(response, `${report_name}.xlsx`);
        showToast(["Report downloaded successfully"], ToastTypes.SUCCESS)
        hideLoader();
      } else {
        hideLoader()
      }
      setEnabledButton(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [downloadReportsData, downloadReportsError]);

  const downloadReport = (reportName: string) => {
    let params = {
      start_date: getValues().start_date,
      end_date: getValues().end_date,
      report_name: reportName
    }
    // if (downloadReportsData || downloadReportsError) clearRequestFileData();
    setLoader();
    setEnabledButton(true)
    downloadRequestForm({}, {}, params);
  }
  const { data: providersListing, mutate: getProvidersListing } =
    useFetch<{ id: number; name: string; }[]>(APIEndpoints.AD_PROVIDER_DROPDOWN, {practice_id: defaultQueryParams?.practice_id
      ? defaultQueryParams.practice_id.split(",")
      : []}, {}, false)

  const practiceChange = (values: any) => {
    // console.log("Selected practice IDs:", values);
    getProvidersListing({}, {}, { practice_id: values });
    //if (values.length === 0) {
      resetField("global_doctor_id");
      setValue("global_doctor_id", "");
    //}
  }

  useEffect(() => {
    if (["GlobalDoctor"].includes(userData?.ref_type || "")) {
      if (providersListing && providersListing.length > 0) {
        const currentDoc = providersListing.find((provider) => provider.id.toString() === userData?.ref_id?.toString());
        setValue("global_doctor_id", currentDoc?.id?.toString() ?? "");
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [providersListing]);

  useEffect(() => {
    if (["Contact", "Practice"].includes(userData?.ref_type || "")) {
      if (practiceDropdown && practiceDropdown.length > 0) {
        setValue("practice_id", practiceDropdown[0].id.toString());
        getProvidersListing({}, {}, { practice_id: practiceDropdown[0].id.toString() });
      }
    } else if (["GlobalDoctor"].includes(userData?.ref_type || "")) {
      if (practiceDropdown && practiceDropdown.length > 0) {
        getProvidersListing({}, {}, { practice_id: practiceDropdown.map((item) => item.id.toString()) });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [practiceDropdown]);

  return (
    <form onSubmit={handleSubmit(searchForStats)}>
      <div className="row g-2 my-3 mt-2 mx-2 statistics-filter">
        <div className="col">
          <Controller
            name="start_date"
            control={control}
            defaultValue=""
            render={({ field }) => (
              <> <DatePicker
                selected={field.value.length > 0 ? parse(field.value, "yyyy-MM-dd", new Date()) : null}
                onChange={(date) => date ? field.onChange(format(date, "yyyy-MM-dd")) : ""}
                customInput={
                  <ReactInputMask mask="99/99/9999">{(inputProps: {}) =>
                    <input {...inputProps} />}
                  </ReactInputMask>
                }
                className="form-control rounded-1" wrapperClassName="w-100"
                placeholderText="mm/dd/yyyy"
                dateFormat="MM/dd/yyyy"
                showMonthDropdown
                showYearDropdown
                maxDate={end_date ? new Date(end_date) : undefined}
              />
                {/* <i
                  className="bi bi-calendar position-absolute"
                  style={{
                    right: "10px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    pointerEvents: "none",
                  }}
                ></i> */}
              </>
            )}
          />
        </div>
        <div className="col">
          <Controller
            name="end_date"
            control={control}
            defaultValue=""
            render={({ field }) => (
              <>
                <DatePicker
                  selected={field.value.length > 0 ? parse(field.value, "yyyy-MM-dd", new Date()) : null}
                  onChange={(date) => date ? field.onChange(format(date, "yyyy-MM-dd")) : ""}
                  customInput={<ReactInputMask mask="99/99/9999">{(inputProps: {}) =>
                    <input {...inputProps} />}</ReactInputMask>}
                  className="form-control rounded-1" wrapperClassName="w-100"
                  placeholderText="mm/dd/yyyy"
                  dateFormat="MM/dd/yyyy"
                  showMonthDropdown
                  showYearDropdown
                  minDate={start_date ? new Date(start_date) : undefined}
                />
                {/* <i
                  className="bi bi-calendar position-absolute"
                  style={{
                    right: "10px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    pointerEvents: "none",
                  }}
                ></i> */}
              </>
            )}
          />
        </div>
        <div className="col">
          <button
            type="button"
            className="btn btn-purple rounded-0 w-100 m-0"
            onClick={() => downloadReport("Downloadable Patient List")}
            disabled={enabledButton}
          >
            {enabledButton ? (
              <i className="spinner-border me-2" style={{ width: `24px`, height: `24px` }}></i>
            ) : null}
            Downloadable Patient List
          </button>
        </div>
        {["Organization"].includes(userData?.ref_type ?? "") && 
          <div className="col">
          <Controller
            name="practice_id"
            control={control}
            defaultValue=""
            render={({ field }) => {
              return (
                <Select
                  id="practice_id"
                  isClearable={false}
                  isSearchable
                  isMulti
                  closeMenuOnSelect={false}
                  maxMenuHeight={220}
                  placeholder="Select Practice ..."
                  isDisabled={["Contact", "Practice"].includes(userData?.ref_type || "")}
                  /* ✅ DO NOT FILTER */
                  options={
                    practiceDropdown?.map((item) => ({
                      label: item.name,
                      value: item.id.toString(),
                    })) ?? []
                  }

                  /* ✅ Value mapping */
                  value={
                    field.value
                      ? field.value.split(",").map((val: string) => {
                        const found = practiceDropdown.find(
                          (item) => item.id.toString() === val
                        );
                        return found
                          ? { label: found.name, value: val }
                          : null;
                      }).filter(Boolean)
                      : []
                  }

                  /* ✅ Safe + fixed onChange */
                  onChange={(selectedOptions: any) => {
                    const values = selectedOptions?.map((opt: any) => opt.value) || [];
                    const commaSeparated = values.join(",");

                    field.onChange(commaSeparated);
                    if (!["GlobalDoctor"].includes(userData?.ref_type || "")) {
                      practiceChange(values);
                    }
                  }}

                  onBlur={field.onBlur}
                  styles={{
                    valueContainer: (base) => ({
                      ...base,
                      maxHeight: '76px',
                      overflowY: 'auto',
                    }),
                    multiValueLabel: (provided) => ({
                      ...provided,
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      maxWidth: 'calc(100% - 20px)',
                      padding: '2px 6px',
                      fontSize: '14px',
                    }),
                  }}
                />
              )
              // return (
              //   <Select
              //     id="practice_id"
              //     placeholder="Select Practice ..."
              //     isClearable={false}
              //     isSearchable
              //     isMulti
              //     closeMenuOnSelect={false}
              //     maxMenuHeight={220}
              //     styles={{
              //       valueContainer: (base) => ({
              //         ...base,
              //         maxHeight: "100px",
              //         //overflowY: "auto",
              //       }),
              //     }}
              //     isDisabled={["Contact", "Practice"].includes(userData?.ref_type || "")}

              //     /* ✅ DO NOT FILTER */
              //     options={
              //       practiceDropdown?.map((item) => ({
              //         label: item.name,
              //         value: item.id.toString(),
              //       })) ?? []
              //     }

              //     /* ✅ Value mapping */
              //     value={
              //       field.value
              //         ? field.value.split(",").map((val: string) => {
              //           const found = practiceDropdown.find(
              //             (item) => item.id.toString() === val
              //           );
              //           return found
              //             ? { label: found.name, value: val }
              //             : null;
              //         }).filter(Boolean)
              //         : []
              //     }

              //     /* ✅ Safe + fixed onChange */
              //     onChange={(selectedOptions: any) => {
              //       const values = selectedOptions?.map((opt: any) => opt.value) || [];
              //       const commaSeparated = values.join(",");

              //       field.onChange(commaSeparated);
              //       if (!["GlobalDoctor"].includes(userData?.ref_type || "")) {
              //         practiceChange(values);
              //       }
              //     }}

              //     onBlur={field.onBlur}
              //   />
              // );
            }}
          />
        </div>}
       {["Organization"].includes(userData?.ref_type ?? "") && (<div className="col">
          <Controller
            name="global_doctor_id"
            control={control}
            defaultValue=""
            render={({ field, fieldState: { error } }) => (
              <Select
                isClearable={true}
                isSearchable={true}
                options={(
                  providersListing &&
                    providersListing.length > 0 ?
                    providersListing.map((item) => ({
                      value: item.id.toString(),
                      label: item.name
                    }))
                    : []
                ) as unknown as OptionsOrGroups<string, GroupBase<string>>}
                id="filter_type"
                {...field}
                placeholder="Select Doctor..."
                isDisabled={["GlobalDoctor"].includes(userData?.ref_type || "")}
                value={(() => {
                  if (field.value) {
                    const foundDoc = providersListing?.find((doc) => doc.id.toString() === ((field.value as unknown as { value: string; })?.value || field.value));
                    return foundDoc ? { label: foundDoc.name, value: foundDoc.id } : "";
                  } else
                    return "";
                })()}
                onChange={(val) => {
                  if (val) field.onChange(val)
                  else {
                    field.onChange("")
                    if (hasAppliedFilters) {
                      searchForStats({ ...getValues(), global_doctor_id: "" });
                    }
                  }
                }}
              />
            )}
          />
        </div>)}
        <div className="col">
          <Controller
            name="global_patient_id"
            control={control}
            defaultValue=""
            render={({ field }) => (
              <input className="form-control" type={"text"} id={'global_patient_id'} placeholder={'Pt. ID'} {...field} />
              // <HubInputField
              //   inputId="global_patient_id"
              //   isRowBased={false}
              //   isRequired={false}
              //   field={field}
              //   inputPlaceholder="Pt. ID"
              // />
            )}
          />
        </div>
        <div className="col">
          <Controller
            name="case_id"
            control={control}
            defaultValue=""
            render={({ field }) => (
              <input className="form-control" type={"text"} id={'case_id'} placeholder={'Case ID'} {...field} />
              // <HubInputField
              //   inputId="case_id"
              //   isRowBased={false}
              //   isRequired={false}
              //   field={field}
              //   inputPlaceholder="Case ID"
              // />
            )}
          />
        </div>
        {isPhiEligible(userData?.ref_type || "") && (
          <div className="col">
            <Controller
              name="patient_name"
              control={control}
              defaultValue=""
              render={({ field }) => (
                <input className="form-control" type={"text"} id={'patient_name'} placeholder={'Patient Name'} {...field} />
              )}
            />
          </div>
        )}
        <div className="col-6 col-md-2 col-lg-1">
          <button
            type="submit"
            className="btn btn-blue border-0 btn-md w-100 rounded-0 text-nowrap"
          >
            <i className="fas fa-search"></i> Find
          </button>
        </div>
        <div className="col-6 col-md-2 col-lg-1">
          <button type="button" onClick={clearFormData} className="btn btn-light btn-md w-100 rounded-0 text-nowrap">
            <i className="bi bi-eraser-fill"></i> Clear
          </button>
        </div>

      </div>
      {isManufacturer && <StatsReports getValues={getValues} />}
    </form>
  );
};

export default PatientFilterHCP;
